import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const ConfigContext = createContext({ config: null, loading: true, refresh: () => {} });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/config");
      setConfig(data);
    } catch {
      // Fail open: render the normal site if /api/config is unreachable
      setConfig({ maintenance: false });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <ConfigContext.Provider value={{ config, loading, refresh }}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
